// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__t9a8N","buttons":"SendReceipts_buttons__c5s3z","email":"SendReceipts_email__3qJP_","bookApptTitle":"SendReceipts_bookApptTitle__1HkG5"};